import amp from 'amplitude-js'
import { environment } from 'src/environments/environment'
import { UserService } from '../user/user.service'

export class Amplitude implements AmplitudeMethods {
  init(): void {
    const uuid = UserService.getUUID()
    const initOptions = {
      includeReferrer: true,
      includeUtm: true,
      includeFbclid: true,
      includeGclid: true,
      saveParamsReferrerOncePerSession: true,
    }
    if (uuid) {
      initOptions['deviceId'] = uuid
    }
    amp.getInstance().init(environment.amplitudeKey, null, initOptions)
  }
  setUserProperties(properties: Record<string, string>): void {
    amp.getInstance().setUserProperties(properties)
  }
  clearUserProperties(): void {
    amp.getInstance().clearUserProperties()
  }
  setUserId(id: string | null): void {
    amp.getInstance().setUserId(`${id}`.padStart(5, '0'))
  }
  logEvent(eventType: string, eventProperties?: Record<string, unknown> | undefined): void {
    amp.getInstance().logEvent(eventType, eventProperties)
  }
}

interface AmplitudeMethods {
  init: () => void
  setUserProperties: (properties: Record<string, string>) => void
  clearUserProperties: () => void
  setUserId: (id: string | null) => void
  logEvent: (eventType: string, eventProperties?: Record<string, unknown> | undefined) => void
}
